module.exports = __webpack_public_path__ + "static/media/Food-3.00c341b4.png";